<template>
  <div>

  <!-- basic Game attributes -->
  <v-form class="mt-2" v-model="valid">
    <v-card class="mb-4">
      <v-card-title>Meta</v-card-title>
      <v-card-text>
        <v-select :rules="[rules.required]" :label="requiredLabel('Locale')" required v-model="item.locale" :items="gameLocales" item-text="name" item-value="value" />

        <v-text-field label="Release Date" type="date" v-model="item.gameReleaseDate" />
        <v-text-field label="Background" type="color" v-model="item.backgroundColor" />

        <v-text-field label="Alias" v-model="item.alias"></v-text-field>
        <v-text-field :rules="[rules.required]" :label="requiredLabel('Name')" required v-model="item.name"></v-text-field>
        <v-text-field label="Tile Rollover" v-model="item.details"></v-text-field>
        <v-text-field label="Full Title" v-model="item.fullTitle"></v-text-field>

        <v-textarea :rules="[rules.required]" :label="requiredLabel('Seo Title')" required v-model="item.htmlTitle" rows="3"/>
        <v-textarea label="Seo Title (Ark.com)" v-model="item.seoTitle" rows="3"/>
        <v-textarea :rules="[rules.required]" :label="requiredLabel('Seo Description')" required v-model="item.htmlDescription" rows="3"/>

        <h4>Description</h4>
        <v-textarea :rules="[rules.required]" :label="requiredLabel('Description')" required v-model="item.description" rows="4"></v-textarea>
        <!-- <PrismEditor v-model="meta.description" language="html" :lineNumbers="true" :readonly="false" /> -->
        <h4>Rules</h4>
        <v-textarea :rules="[rules.required]" :label="requiredLabel('Rules')" required v-model="item.rules" rows="4"></v-textarea>
        <!-- <PrismEditor v-model="meta.rules" language="html" :lineNumbers="true" :readonly="false" /> -->

        <v-combobox label="Primary Category" v-model="item.primaryCategory"
                    :items="categories.filter(c => c.locale === item.locale)" item-text="name" return-object />
        <v-combobox :rules="[rules.atLeastOne]" :label="requiredLabel('Categories')" required v-model="item.categories"
                    :items="categories.filter(c => c.locale === item.locale)" item-text="name" return-object chips multiple>
        </v-combobox>
        <v-combobox label="Tags" v-model="item.tags"
                    :items="tags.filter(c => c.locale === item.locale)" item-text="name" return-object chips multiple>
        </v-combobox>
        <v-combobox label="Badges" v-model="item.badges"
                    :items="badges.filter(c => c.locale === item.locale)" item-text="name" return-object chips multiple>
        </v-combobox>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" data-testid="game-meta-form-save" @click="save()" :disabled="!valid">Save</v-btn>
      </v-card-actions>
      <v-card-text>
        <Thumbs
          v-if="item.id"
          :metaId="item.id"
          :game="game"
          :thumbs="item.thumbs"
          @change="$emit('change-thumb')"
        />
      </v-card-text>
    </v-card>
  </v-form>
  <!-- / basic Game attributes -->

  </div>
</template>

<script>
import { gameLocales } from '@/constants/locales';
import Thumbs from '../../../components/Thumbs/Thumbs.vue';
import PrismEditor from 'vue-prism-editor'

export default {
  name: 'MetaForm',
  components: { Thumbs, PrismEditor },
  props: {
    parent: {},
    game: {},
    item: {},
  },
  created() {
    this.$gameApi.get('/dictionary/categories').then(categories => this.categories = categories);
    this.$gameApi.get('/dictionary/tags').then(tags => this.tags = tags);
    this.$gameApi.get('/dictionary/badges').then(badges => this.badges = badges);
  },
  data() {
    return {
      gameLocales,
      categories: [],
      tags: [],
      badges: [],
      valid: false,
      rules: {
        required: value => !!value || 'Required.',
        atLeastOne: value => value.length > 0 || 'Pick at least one.',
      },
    };
  },
  watch: {
    'item.locale': {
      handler(newLocale) {
        this.prefillAlias(newLocale);
      },
    },
    parent: {
      handler() {
        this.prefillAlias(this.item?.locale);
      },
      immediate: true,
    },
  },
  methods: {
    prefillAlias(locale) {
      if (!locale || locale === 'en') {
        return;
      }

      if (this.item?.alias && this.item.alias.trim()) {
        return;
      }

      const englishAlias = this.parent?.gameMetas
        ?.find(meta => meta.locale === 'en' && meta.alias && meta.alias.trim())
        ?.alias.trim();

      if (englishAlias) {
        this.$set(this.item, 'alias', englishAlias);
      }
    },
    requiredLabel(label) {
      return `${label} *`;
    },
    save() {
      this.$emit('change', this.item);
    }
  }
};
</script>
